import { useEffect, useRef, useState } from 'react';
import { useChatContext } from '../../../../../../Chat.hook';

export default function useAIResponseAction() {
  const { selectedChat } = useChatContext();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const portalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsOpen(false);
  }, [selectedChat?.id]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node;
      if (
        dropdownRef.current && !dropdownRef.current.contains(target) &&
        (!portalRef.current || !portalRef.current.contains(target))
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function handleToggle(e: React.MouseEvent) {
    e.preventDefault();
    setIsOpen(!isOpen);
  }

  function closeMenu() {
    setIsOpen(false);
  }

  return {
    dropdownRef,
    portalRef,
    isOpen,
    isLoading,
    handleToggle,
    closeMenu,
    selectedChat,
  };
}
